(function() {
    window.iosDeviceList = [{
        "Identifier": "i386",
        "Name": "iPhone Simulator"
    }, {
        "Identifier": "x86_64",
        "Name": "iPhone Simulator"
    }, {
        "Identifier": "arm64",
        "Name": "iPhone Simulator"
    }, {
        "Identifier": "iPhone1,1",
        "Name": "iPhone"
    }, {
        "Identifier": "iPhone1,2",
        "Name": "iPhone 3G"
    }, {
        "Identifier": "iPhone2,1",
        "Name": "iPhone 3GS"
    }, {
        "Identifier": "iPhone3,1",
        "Name": "iPhone 4"
    }, {
        "Identifier": "iPhone3,2",
        "Name": "iPhone 4 GSM Rev A"
    }, {
        "Identifier": "iPhone3,3",
        "Name": "iPhone 4 CDMA"
    }, {
        "Identifier": "iPhone4,1",
        "Name": "iPhone 4S"
    }, {
        "Identifier": "iPhone5,1",
        "Name": "iPhone 5 (GSM)"
    }, {
        "Identifier": "iPhone5,2",
        "Name": "iPhone 5 (GSM+CDMA)"
    }, {
        "Identifier": "iPhone5,3",
        "Name": "iPhone 5C (GSM)"
    }, {
        "Identifier": "iPhone5,4",
        "Name": "iPhone 5C (Global)"
    }, {
        "Identifier": "iPhone6,1",
        "Name": "iPhone 5S (GSM)"
    }, {
        "Identifier": "iPhone6,2",
        "Name": "iPhone 5S (Global)"
    }, {
        "Identifier": "iPhone7,1",
        "Name": "iPhone 6 Plus"
    }, {
        "Identifier": "iPhone7,2",
        "Name": "iPhone 6"
    }, {
        "Identifier": "iPhone8,1",
        "Name": "iPhone 6s"
    }, {
        "Identifier": "iPhone8,2",
        "Name": "iPhone 6s Plus"
    }, {
        "Identifier": "iPhone8,4",
        "Name": "iPhone SE (GSM)"
    }, {
        "Identifier": "iPhone9,1",
        "Name": "iPhone 7"
    }, {
        "Identifier": "iPhone9,2",
        "Name": "iPhone 7 Plus"
    }, {
        "Identifier": "iPhone9,3",
        "Name": "iPhone 7"
    }, {
        "Identifier": "iPhone9,4",
        "Name": "iPhone 7 Plus"
    }, {
        "Identifier": "iPhone10,1",
        "Name": "iPhone 8"
    }, {
        "Identifier": "iPhone10,2",
        "Name": "iPhone 8 Plus"
    }, {
        "Identifier": "iPhone10,3",
        "Name": "iPhone X Global"
    }, {
        "Identifier": "iPhone10,4",
        "Name": "iPhone 8"
    }, {
        "Identifier": "iPhone10,5",
        "Name": "iPhone 8 Plus"
    }, {
        "Identifier": "iPhone10,6",
        "Name": "iPhone X GSM"
    }, {
        "Identifier": "iPhone11,2",
        "Name": "iPhone XS"
    }, {
        "Identifier": "iPhone11,4",
        "Name": "iPhone XS Max"
    }, {
        "Identifier": "iPhone11,6",
        "Name": "iPhone XS Max Global"
    }, {
        "Identifier": "iPhone11,8",
        "Name": "iPhone XR"
    }, {
        "Identifier": "iPhone12,1",
        "Name": "iPhone 11"
    }, {
        "Identifier": "iPhone12,3",
        "Name": "iPhone 11 Pro"
    }, {
        "Identifier": "iPhone12,5",
        "Name": "iPhone 11 Pro Max"
    }, {
        "Identifier": "iPhone12,8",
        "Name": "iPhone SE 2nd Gen"
    }, {
        "Identifier": "iPhone13,1",
        "Name": "iPhone 12 Mini"
    }, {
        "Identifier": "iPhone13,2",
        "Name": "iPhone 12"
    }, {
        "Identifier": "iPhone13,3",
        "Name": "iPhone 12 Pro"
    }, {
        "Identifier": "iPhone13,4",
        "Name": "iPhone 12 Pro Max"
    }, {
        "Identifier": "iPhone14,2",
        "Name": "iPhone 13 Pro"
    }, {
        "Identifier": "iPhone14,3",
        "Name": "iPhone 13 Pro Max"
    }, {
        "Identifier": "iPhone14,4",
        "Name": "iPhone 13 Mini"
    }, {
        "Identifier": "iPhone14,5",
        "Name": "iPhone 13"
    }, {
        "Identifier": "iPhone14,6",
        "Name": "iPhone SE 3rd Gen"
    }, {
        "Identifier": "iPhone14,7",
        "Name": "iPhone 14"
    }, {
        "Identifier": "iPhone14,8",
        "Name": "iPhone 14 Plus"
    }, {
        "Identifier": "iPhone15,2",
        "Name": "iPhone 14 Pro"
    },
        {
            "Identifier": "iPhone15,3",
            "Name": "iPhone 14 Pro Max"
        },
        {
            "Identifier": "iPhone15,4",
            "Name": "iPhone 15"
        },
        {
            "Identifier": "iPhone15,5",
            "Name": "iPhone 15 Plus"
        },
        {
            "Identifier": "iPhone16,1",
            "Name": "iPhone 15 Pro"
        },
        {
            "Identifier": "iPhone16,2",
            "Name": "iPhone 15 Pro Max"
        },
        {
            "Identifier": "iPod1,1",
            "Name": "1st Gen iPod"
        }, {
            "Identifier": "iPod2,1",
            "Name": "2nd Gen iPod"
        }, {
            "Identifier": "iPod3,1",
            "Name": "3rd Gen iPod"
        }, {
            "Identifier": "iPod4,1",
            "Name": "4th Gen iPod"
        }, {
            "Identifier": "iPod5,1",
            "Name": "5th Gen iPod"
        }, {
            "Identifier": "iPod7,1",
            "Name": "6th Gen iPod"
        }, {
            "Identifier": "iPod9,1",
            "Name": "7th Gen iPod"
        }, {
            "Identifier": "iPad1,1",
            "Name": "iPad"
        }, {
            "Identifier": "iPad1,2",
            "Name": "iPad 3G"
        }, {
            "Identifier": "iPad2,1",
            "Name": "2nd Gen iPad"
        }, {
            "Identifier": "iPad2,2",
            "Name": "2nd Gen iPad GSM"
        }, {
            "Identifier": "iPad2,3",
            "Name": "2nd Gen iPad CDMA"
        }, {
            "Identifier": "iPad2,4",
            "Name": "2nd Gen iPad New Revision"
        }, {
            "Identifier": "iPad3,1",
            "Name": "3rd Gen iPad"
        }, {
            "Identifier": "iPad3,2",
            "Name": "3rd Gen iPad CDMA"
        }, {
            "Identifier": "iPad3,3",
            "Name": "3rd Gen iPad GSM"
        }, {
            "Identifier": "iPad2,5",
            "Name": "iPad mini"
        }, {
            "Identifier": "iPad2,6",
            "Name": "iPad mini GSM+LTE"
        }, {
            "Identifier": "iPad2,7",
            "Name": "iPad mini CDMA+LTE"
        }, {
            "Identifier": "iPad3,4",
            "Name": "4th Gen iPad"
        }, {
            "Identifier": "iPad3,5",
            "Name": "4th Gen iPad GSM+LTE"
        }, {
            "Identifier": "iPad3,6",
            "Name": "4th Gen iPad CDMA+LTE"
        }, {
            "Identifier": "iPad4,1",
            "Name": "iPad Air (WiFi)"
        }, {
            "Identifier": "iPad4,2",
            "Name": "iPad Air (GSM+CDMA)"
        }, {
            "Identifier": "iPad4,3",
            "Name": "1st Gen iPad Air (China)"
        }, {
            "Identifier": "iPad4,4",
            "Name": "iPad mini Retina (WiFi)"
        }, {
            "Identifier": "iPad4,5",
            "Name": "iPad mini Retina (GSM+CDMA)"
        }, {
            "Identifier": "iPad4,6",
            "Name": "iPad mini Retina (China)"
        }, {
            "Identifier": "iPad4,7",
            "Name": "iPad mini 3 (WiFi)"
        }, {
            "Identifier": "iPad4,8",
            "Name": "iPad mini 3 (GSM+CDMA)"
        }, {
            "Identifier": "iPad4,9",
            "Name": "iPad Mini 3 (China)"
        }, {
            "Identifier": "iPad5,1",
            "Name": "iPad mini 4 (WiFi)"
        }, {
            "Identifier": "iPad5,2",
            "Name": "4th Gen iPad mini (WiFi+Cellular)"
        }, {
            "Identifier": "iPad5,3",
            "Name": "iPad Air 2 (WiFi)"
        }, {
            "Identifier": "iPad5,4",
            "Name": "iPad Air 2 (Cellular)"
        }, {
            "Identifier": "iPad6,3",
            "Name": "iPad Pro (9.7 inch, WiFi)"
        }, {
            "Identifier": "iPad6,4",
            "Name": "iPad Pro (9.7 inch, WiFi+LTE)"
        }, {
            "Identifier": "iPad6,7",
            "Name": "iPad Pro (12.9 inch, WiFi)"
        }, {
            "Identifier": "iPad6,8",
            "Name": "iPad Pro (12.9 inch, WiFi+LTE)"
        }, {
            "Identifier": "iPad6,11",
            "Name": "iPad (2017)"
        }, {
            "Identifier": "iPad6,12",
            "Name": "iPad (2017)"
        }, {
            "Identifier": "iPad7,1",
            "Name": "iPad Pro 2nd Gen (WiFi)"
        }, {
            "Identifier": "iPad7,2",
            "Name": "iPad Pro 2nd Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad7,3",
            "Name": "iPad Pro 10.5-inch 2nd Gen"
        }, {
            "Identifier": "iPad7,4",
            "Name": "iPad Pro 10.5-inch 2nd Gen"
        }, {
            "Identifier": "iPad7,5",
            "Name": "iPad 6th Gen (WiFi)"
        }, {
            "Identifier": "iPad7,6",
            "Name": "iPad 6th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad7,11",
            "Name": "iPad 7th Gen 10.2-inch (WiFi)"
        }, {
            "Identifier": "iPad7,12",
            "Name": "iPad 7th Gen 10.2-inch (WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,1",
            "Name": "iPad Pro 11 inch 3rd Gen (WiFi)"
        }, {
            "Identifier": "iPad8,2",
            "Name": "iPad Pro 11 inch 3rd Gen (1TB, WiFi)"
        }, {
            "Identifier": "iPad8,3",
            "Name": "iPad Pro 11 inch 3rd Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,4",
            "Name": "iPad Pro 11 inch 3rd Gen (1TB, WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,5",
            "Name": "iPad Pro 12.9 inch 3rd Gen (WiFi)"
        }, {
            "Identifier": "iPad8,6",
            "Name": "iPad Pro 12.9 inch 3rd Gen (1TB, WiFi)"
        }, {
            "Identifier": "iPad8,7",
            "Name": "iPad Pro 12.9 inch 3rd Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,8",
            "Name": "iPad Pro 12.9 inch 3rd Gen (1TB, WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,9",
            "Name": "iPad Pro 11 inch 4th Gen (WiFi)"
        }, {
            "Identifier": "iPad8,10",
            "Name": "iPad Pro 11 inch 4th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad8,11",
            "Name": "iPad Pro 12.9 inch 4th Gen (WiFi)"
        }, {
            "Identifier": "iPad8,12",
            "Name": "iPad Pro 12.9 inch 4th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad11,1",
            "Name": "iPad mini 5th Gen (WiFi)"
        }, {
            "Identifier": "iPad11,2",
            "Name": "iPad mini 5th Gen"
        }, {
            "Identifier": "iPad11,3",
            "Name": "iPad Air 3rd Gen (WiFi)"
        }, {
            "Identifier": "iPad11,4",
            "Name": "iPad Air 3rd Gen"
        }, {
            "Identifier": "iPad11,6",
            "Name": "iPad 8th Gen (WiFi)"
        }, {
            "Identifier": "iPad11,7",
            "Name": "iPad 8th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad12,1",
            "Name": "iPad 9th Gen (WiFi)"
        }, {
            "Identifier": "iPad12,2",
            "Name": "iPad 9th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad14,1",
            "Name": "iPad mini 6th Gen (WiFi)"
        }, {
            "Identifier": "iPad14,2",
            "Name": "iPad mini 6th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad13,1",
            "Name": "iPad Air 4th Gen (WiFi)"
        }, {
            "Identifier": "iPad13,2",
            "Name": "iPad Air 4th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad13,4",
            "Name": "iPad Pro 11 inch 5th Gen"
        }, {
            "Identifier": "iPad13,5",
            "Name": "iPad Pro 11 inch 5th Gen"
        }, {
            "Identifier": "iPad13,6",
            "Name": "iPad Pro 11 inch 5th Gen"
        }, {
            "Identifier": "iPad13,7",
            "Name": "iPad Pro 11 inch 5th Gen"
        }, {
            "Identifier": "iPad13,8",
            "Name": "iPad Pro 12.9 inch 5th Gen"
        }, {
            "Identifier": "iPad13,9",
            "Name": "iPad Pro 12.9 inch 5th Gen"
        }, {
            "Identifier": "iPad13,10",
            "Name": "iPad Pro 12.9 inch 5th Gen"
        }, {
            "Identifier": "iPad13,11",
            "Name": "iPad Pro 12.9 inch 5th Gen"
        }, {
            "Identifier": "iPad13,16",
            "Name": "iPad Air 5th Gen (WiFi)"
        }, {
            "Identifier": "iPad13,17",
            "Name": "iPad Air 5th Gen (WiFi+Cellular)"
        }, {
            "Identifier": "iPad13,18",
            "Name": "iPad 10th Gen"
        }, {
            "Identifier": "iPad13,19",
            "Name": "iPad 10th Gen"
        }, {
            "Identifier": "iPad14,3-A",
            "Name": "iPad Pro 11 inch 4th Gen"
        }, {
            "Identifier": "iPad14,3-B",
            "Name": "iPad Pro 11 inch 4th Gen"
        }, {
            "Identifier": "iPad14,4-A",
            "Name": "iPad Pro 11 inch 4th Gen"
        }, {
            "Identifier": "iPad14,4-B",
            "Name": "iPad Pro 11 inch 4th Gen"
        }, {
            "Identifier": "iPad14,5-A",
            "Name": "iPad Pro 12.9 inch 6th Gen"
        }, {
            "Identifier": "iPad14,5-B",
            "Name": "iPad Pro 12.9 inch 6th Gen"
        }, {
            "Identifier": "iPad14,6-A",
            "Name": "iPad Pro 12.9 inch 6th Gen"
        }, {
            "Identifier": "iPad14,6-B",
            "Name": "iPad Pro 12.9 inch 6th Gen"
        }, {
            "Identifier": "Watch1,1",
            "Name": "Apple Watch 38mm case"
        }, {
            "Identifier": "Watch1,2",
            "Name": "Apple Watch 42mm case"
        }, {
            "Identifier": "Watch2,6",
            "Name": "Apple Watch Series 1 38mm case"
        }, {
            "Identifier": "Watch2,7",
            "Name": "Apple Watch Series 1 42mm case"
        }, {
            "Identifier": "Watch2,3",
            "Name": "Apple Watch Series 2 38mm case"
        }, {
            "Identifier": "Watch2,4",
            "Name": "Apple Watch Series 2 42mm case"
        }, {
            "Identifier": "Watch3,1",
            "Name": "Apple Watch Series 3 38mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch3,2",
            "Name": "Apple Watch Series 3 42mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch3,3",
            "Name": "Apple Watch Series 3 38mm case (GPS)"
        }, {
            "Identifier": "Watch3,4",
            "Name": "Apple Watch Series 3 42mm case (GPS)"
        }, {
            "Identifier": "Watch4,1",
            "Name": "Apple Watch Series 4 40mm case (GPS)"
        }, {
            "Identifier": "Watch4,2",
            "Name": "Apple Watch Series 4 44mm case (GPS)"
        }, {
            "Identifier": "Watch4,3",
            "Name": "Apple Watch Series 4 40mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch4,4",
            "Name": "Apple Watch Series 4 44mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch5,1",
            "Name": "Apple Watch Series 5 40mm case (GPS)"
        }, {
            "Identifier": "Watch5,2",
            "Name": "Apple Watch Series 5 44mm case (GPS)"
        }, {
            "Identifier": "Watch5,3",
            "Name": "Apple Watch Series 5 40mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch5,4",
            "Name": "Apple Watch Series 5 44mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch5,9",
            "Name": "Apple Watch SE 40mm case (GPS)"
        }, {
            "Identifier": "Watch5,10",
            "Name": "Apple Watch SE 44mm case (GPS)"
        }, {
            "Identifier": "Watch5,11",
            "Name": "Apple Watch SE 40mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch5,12",
            "Name": "Apple Watch SE 44mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,1",
            "Name": "Apple Watch Series 6 40mm case (GPS)"
        }, {
            "Identifier": "Watch6,2",
            "Name": "Apple Watch Series 6 44mm case (GPS)"
        }, {
            "Identifier": "Watch6,3",
            "Name": "Apple Watch Series 6 40mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,4",
            "Name": "Apple Watch Series 6 44mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,6",
            "Name": "Apple Watch Series 7 41mm case (GPS)"
        }, {
            "Identifier": "Watch6,7",
            "Name": "Apple Watch Series 7 45mm case (GPS)"
        }, {
            "Identifier": "Watch6,8",
            "Name": "Apple Watch Series 7 41mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,9",
            "Name": "Apple Watch Series 7 45mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,10",
            "Name": "Apple Watch SE 40mm case (GPS)"
        }, {
            "Identifier": "Watch6,11",
            "Name": "Apple Watch SE 44mm case (GPS)"
        }, {
            "Identifier": "Watch6,12",
            "Name": "Apple Watch SE 40mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,13",
            "Name": "Apple Watch SE 44mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,14",
            "Name": "Apple Watch Series 8 41mm case (GPS)"
        }, {
            "Identifier": "Watch6,15",
            "Name": "Apple Watch Series 8 45mm case (GPS)"
        }, {
            "Identifier": "Watch6,16",
            "Name": "Apple Watch Series 8 41mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,17",
            "Name": "Apple Watch Series 8 45mm case (GPS+Cellular)"
        }, {
            "Identifier": "Watch6,18",
            "Name": "Apple Watch Ultra"
        }
    ];
}());